export const RECOVERY_EMAIL_HUTECH_CONST = {
  STATUS: {
    DANG_XU_LY: 'chua_xu_ly',
    DA_XU_LY: 'da_xu_ly',
  }
}
